import React from 'react';
import { Container } from '../ui/Container';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { Textarea } from '../ui/Textarea';
import { ShieldCheck, ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <Section className="bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden" id="quote" data-id="element-191">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500 rounded-full mix-blend-overlay filter blur-3xl opacity-10 animate-blob" data-id="element-192"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-magenta-500 rounded-full mix-blend-overlay filter blur-3xl opacity-10 animate-blob animation-delay-2000" data-id="element-193"></div>

      <Container className="relative z-10" data-id="element-194">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-195">
          {/* Left: Copy & Mascot */}
          <div className="lg:col-span-5 text-center lg:text-left" data-id="element-196">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight" data-id="element-197">
              Ready to make an{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-magenta-400" data-id="element-198">
                impression?
              </span>
            </h2>
            <p className="text-gray-300 text-lg mb-8" data-id="element-199">
              Our Inklings are standing by to help! Tell us about your project
              and we'll get back to you with a fast, custom quote.
            </p>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/10 mb-8 inline-block text-left" data-id="element-200">
              <div className="flex items-center gap-4 mb-4" data-id="element-201">
                <div className="p-2 bg-green-500/20 rounded-full text-green-400" data-id="element-202">
                  <ShieldCheck className="h-6 w-6" data-id="element-203" />
                </div>
                <div data-id="element-204">
                  <h4 className="font-bold text-white" data-id="element-205">Our Promise</h4>
                  <p className="text-sm text-gray-300" data-id="element-206">
                    Quality guaranteed or we reprint for free.
                  </p>
                </div>
              </div>
              <div className="flex gap-2" data-id="element-207">
                <span className="px-2 py-1 bg-cyan-500/20 text-cyan-300 text-xs rounded border border-cyan-500/30" data-id="element-208">
                  Fast Turnaround
                </span>
                <span className="px-2 py-1 bg-magenta-500/20 text-magenta-300 text-xs rounded border border-magenta-500/30" data-id="element-209">
                  Expert Support
                </span>
              </div>
            </div>

            <div className="hidden lg:block relative h-48" data-id="element-210">
              <img src="https://cdn.magicpatterns.com/uploads/oRjVdEwcjrJByMjpUoNSga/cute-colour-inkling.png" alt="Friendly Mascot" className="absolute left-0 bottom-0 w-40 h-auto drop-shadow-2xl animate-float" data-id="element-211" />
            </div>
          </div>

          {/* Right: Simplified Form */}
          <div className="lg:col-span-7" data-id="element-212">
            <div className="bg-white rounded-3xl p-6 md:p-10 text-gray-900 shadow-2xl relative" data-id="element-213">
              <div className="absolute -top-4 -right-4 bg-yellow-400 text-gray-900 text-xs font-bold px-3 py-1 rounded-full shadow-md transform rotate-6" data-id="element-214">
                FAST & FREE
              </div>

              <div className="mb-6 flex justify-between items-center" data-id="element-215">
                <h3 className="text-xl font-bold" data-id="element-216">Get Your Free Quote</h3>
                <div className="flex gap-1" data-id="element-217">
                  <div className="w-2 h-2 rounded-full bg-cyan-500" data-id="element-218"></div>
                  <div className="w-2 h-2 rounded-full bg-magenta-500" data-id="element-219"></div>
                  <div className="w-2 h-2 rounded-full bg-yellow-500" data-id="element-220"></div>
                </div>
              </div>

              <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-221">
                <Select label="What do you need?" options={[{
                value: '',
                label: 'Select a product...'
              }, {
                value: 'business-cards',
                label: 'Business Cards'
              }, {
                value: 'brochures',
                label: 'Brochures, Flyers & Greeting Cards'
              }, {
                value: 'booklets',
                label: 'Booklets & Magazines'
              }, {
                value: 'stationery',
                label: 'Printed Stationery'
              }, {
                value: 'ncr',
                label: 'NCR Books'
              }, {
                value: 'posters',
                label: 'Posters & Banners'
              }, {
                value: 'signage',
                label: 'Signage & Installation'
              }, {
                value: 'decals',
                label: 'Decals, Stickers & Labels'
              }, {
                value: 'apparel',
                label: 'Apparel & Workwear'
              }, {
                value: 'promo',
                label: 'Promotional Items'
              }, {
                value: 'design',
                label: 'Design Services'
              }, {
                value: 'other',
                label: 'Other / Custom'
              }]} className="bg-gray-50" data-id="element-222" />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-223">
                  <Input label="Name" placeholder="Your name" className="bg-gray-50" data-id="element-224" />
                  <Input label="Email" placeholder="your@email.com" type="email" className="bg-gray-50" data-id="element-225" />
                </div>

                <Input label="Phone" placeholder="Your phone number" type="tel" className="bg-gray-50" data-id="element-226" />

                <Textarea label="Project Details" placeholder="Tell us a bit about what you need (quantity, size, finish...)" rows={3} className="bg-gray-50" data-id="element-227" />

                <Button fullWidth size="lg" className="bg-gradient-to-r from-cyan-500 to-magenta-500 hover:from-cyan-600 hover:to-magenta-600 border-0 shadow-lg text-lg py-4" data-id="element-228">
                  Get My Free Quote
                  <ArrowRight className="ml-2 h-5 w-5" data-id="element-229" />
                </Button>

                <p className="text-xs text-center text-gray-400 mt-4" data-id="element-230">
                  No obligation. We usually reply within 2 hours during business
                  days.
                </p>
              </form>
            </div>
          </div>
        </div>
      </Container>
    </Section>;
}